// config.js

// Base API URL for backend
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// Optional flags or settings
export const IS_PRODUCTION = process.env.NODE_ENV === "production";

export const FEATURES = {
  ENABLE_BETA_FEATURES: process.env.REACT_APP_ENABLE_BETA === "true",
};